const updateQuestionSectionsResponses = (
	questionSections: any,
	currentCampaignForm: any,
	questionsResponse: any,
) =>
	questionSections.map((questionSection: any) => {
		if (questionSection.id === currentCampaignForm.id) {
			return {
				...questionSection,
				questions: questionSection.questions.map((question: any) => {
					return {
						...question,
						campaignQuestionAnswer: {
							id: question.campaignQuestionAnswer.id,
							questionAnswerId:
								questionsResponse.find(
									(response: any) =>
										response.id === question.campaignQuestionAnswer.id,
								)?.questionAnswerId || null,
						},
					}
				}),
			}
		} else {
			return questionSection
		}
	})

export default updateQuestionSectionsResponses
